var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
        'progress-bar': true,
        'progress-bar--animated': _vm.animation
    }, _obj[("progress-bar--" + _vm.theme)] = (_vm.theme || null), _obj )},[_c('div',{staticClass:"progress-bar__percentage",style:({ width: (_vm.thePercentage + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }